/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import { NativeTypes } from 'react-dnd-html5-backend';

const { FILE } = NativeTypes;

const ItemTypes = {
  RESULT: 'Result',
  READY_RESULT: 'readyResult',
  SPRINT_RESULT: 'sprintResult',
  KANBAN_CARD: 'kanbanCard',
  ACTIVITY: 'Activity',
  TASK: 'task',
  USER: 'user',
  PRODUCT: 'product',
  FILE
};

export default ItemTypes;
